import { useEffect } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-gpx'; // ✅ This attaches GPX support to Leaflet

L.Icon.Default.imagePath =
  'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/';

const GPXLayer = ({ url }: { url: string }) => {
  const map = useMap(); // This must be inside MapContainer

  useEffect(() => {
    if (!map) return;

    fetch(url)
      .then((response) => response.text())
      .then((gpxString) => {
        const gpxLayer = new L.GPX(gpxString, {
          async: true,
          polyline_options: {
            color: '#C4FF00',
            weight: 4,
            opacity: 0.95,
          },
        }).on('loaded', (e) => {
          map.fitBounds(e.target.getBounds()); // Fit the GPX track into view
        });

        map.addLayer(gpxLayer);
      });
  }, [url, map]);

  return null; // No UI component needed here
};

export const Map = ({ url }: { url: string }) => {
  return (
    <div style={{ height: '350px', width: '100%' }}>
      <MapContainer
        center={[51.505, -0.09]}
        zoom={13}
        style={{ height: '100%', width: '100%', zIndex: 0 }}
      >
        <TileLayer
          url={`https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=${encodeURIComponent(import.meta.env.OPENMAPS_API_KEY || '')}`}
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>'
        />
        <GPXLayer url={url} />
      </MapContainer>
    </div>
  );
};

export default Map;
